import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  showCloseButton = true,
  closeOnOverlayClick = true,
  maxWidth = 'max-w-md',
  actions = null
}) => {
  useEffect(() => {
    if (isOpen) {
      // Lock body scroll when modal opens
      document.body.classList.add('modal-open');
    } else {
      // Unlock body scroll when modal closes
      document.body.classList.remove('modal-open');
    }

    // Cleanup function to ensure body scroll is unlocked
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  useEffect(() => {
    // Handle escape key
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  // Prevent body scroll but allow modal scrolling
  const handleOverlayScroll = (e) => {
    // Allow scrolling within the overlay
    e.stopPropagation();
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={handleOverlayClick}
      onScroll={handleOverlayScroll}
    >
      <div className={`modal-content ${maxWidth}`}>
        {/* Header */}
        {title && (
          <div className="modal-header">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
              {showCloseButton && (
                <button
                  onClick={onClose}
                  className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              )}
            </div>
          </div>
        )}

        {/* Body */}
        <div className="modal-body">
          {children}
        </div>

        {/* Footer/Actions */}
        {actions && (
          <div className="modal-footer">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal; 